// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_CheckQrcodeUniqueResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/check_qrcode_unique
 *
 * Whether a QR code is available (unique) for the franchise across all
 * in-process order items (not cancelled/entregue).
 *
 * Default false so any error/guard path stays fail-closed (never reports an
 * unchecked QR as available).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_CheckQrcodeUniqueResponseDados {
unique: boolean
}

export type Orders_CheckQrcodeUniqueResponse = ApiResponse<Orders_CheckQrcodeUniqueResponseDados>;

registerResponseContract('Orders_CheckQrcodeUniqueResponse', {
  unique: { type: 'boolean', required: true },
})
